import React, { useEffect, useState } from "react";
import CommuBrdPstdCmntApi from "Apis/CommuBrdPstdCmntApi";
import CommuCmntWriteUi from "Views/Commu/CommuCmntWriteUi";
import type { CommuBrdPstdCmntItem } from "Apis/CommuBrdPstdCmntApi";
import Pagination from "react-js-pagination";

const CommuCmntUi = ({ brdCd, brdPstdSno }: any) => {
    const [comments, setComments] = useState<CommuBrdPstdCmntItem[]>([]);
    const [page, setPage] = useState<number>(1);
    const [onePageSizeState, setOnePageSizeState] = useState<number>(10);
    const [totPstdCntState, setTotPstdCntState] = useState<number>(0);

    const handlePageChange = (nextPage: number) => {
        setPage(nextPage);
    };

    useEffect(() => {
        CommuBrdPstdCmntApi(brdCd, brdPstdSno,page)
        .then((Resp) => {
            setComments(Resp?.apiBody?.brdPstdCmntLst || []);
            setPage(Resp?.apiBody?.nowPageNo || 1);
            setOnePageSizeState(Resp?.apiBody?.onePageSize || 10);
            setTotPstdCntState(Resp?.apiBody?.totCnt || 0);
        })
        .catch((Err) => {
            console.error(Err);
        });
    }, [brdCd, brdPstdSno, page]);

    return (
        <>
            <div>
                <ul>
                    {comments.map((item) => (
                        <li key={item.brdPstdCmntSno}>
                            <div>
                                <p>{item.nickname}</p>
                            </div>
                            <div santize-html="true" dangerouslySetInnerHTML={{ __html: item.cmntCtxt }}>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="ctntPageWrap">
                <Pagination
                    activePage={page}
                    itemsCountPerPage={onePageSizeState}
                    totalItemsCount={totPstdCntState}
                    pageRangeDisplayed={5}
                    firstPageText={""}
                    linkClassFirst={"pagenationBtn pagenationFirstBtn"}
                    prevPageText={""}
                    linkClassPrev={"pagenationBtn pagenationPrevBtn"}
                    nextPageText={""}
                    linkClassNext={"pagenationBtn pagenationNextBtn"}
                    lastPageText={""}
                    linkClassLast={"pagenationBtn pagenationLastBtn"}
                    onChange={handlePageChange}
                />
            </div>
        </>
    );
};

export default CommuCmntUi;